<template>
    <div>
        <b-dropdown boundary="viewport" lazy right offset="-100px" dropleft variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
                <!-- <svg class="icon dropdown-toggle">
                    <use :xlink:href="'/assets/images/' + iconName"></use>
                </svg> -->
                <div :style="{color:iconColor}" class="dots-holder">
                    <b-icon-three-dots-vertical/>
                </div>
            </template>
            <template v-for="(option, index) in options">
                <div :key="index" :class="option.class">
                    <b-dropdown-item-button v-if="option.shouldRender" :key="index" @click.stop="option.handler">
                    <img :src="'/img/' + option.icon">{{option.name}}
                </b-dropdown-item-button>
                </div>
            </template>
        </b-dropdown>
    </div>
</template>
<script>
    // the options prop is an array of objects
    // each object contains name and handler property
    // and shouldRender property is a boolean to tell if to render a particular menu
    import {BIconThreeDotsVertical} from "bootstrap-vue"
    export default {
        props: {
            'iconName': {
                type: String,
                default: 'sprite.svg#vertical-ellipsis',
            },
            iconColor:{
                type:String,
                default:"white"
            },
            'options': {
                type: Array,
                required: true,
            },
        },
        components:{
            BIconThreeDotsVertical
        }
    }
</script>
<style scoped>

.dropdown svg {
    cursor: pointer;
    width: 25px;
    height: 25px;
    padding: 5px 0;
    border-radius: 50%;
}

.dropdown svg:hover {
    background-color: #F4F4F4;
}

.dropdown .dropdown-menu {
    position: absolute;
    top: 24px !important;
    left: -100px !important;
    border: none;
    border-radius: 6px;
    box-shadow: 0 0 20px 0 rgba(226, 222, 222, 0.5);
    outline: none;
    min-width: fit-content;
    height: auto !important;
    padding: 0;
}

.dropdown>button {
    padding: 0;
    color: #535353;
}

.dropdown>.dropdown-menu li {
    width: fit-content;
    padding: 0;
    height: auto;
    width: 100%;
}

.dropdown>.dropdown-menu li:hover {
    border: none;
    background-color: #F8F9FA;
}

.dropdown>.dropdown-menu li>button {
    padding: 5px 7px 10px 7px;
    margin: 4px 0;
    height: 25px;
    color: #535353;
    font-size: 14px;
}

.dropdown>.dropdown-menu li>button>img {
    width: 16px;
    height: 15px;
    margin-right: 10px;
}
</style>